import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, CircularProgress, Stack } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { SUPPORTED_LANGS, getAcceptLanguageHeader, useI18n } from '../i18n';

export default function LoginPage() {
  const { login } = useAuth();
  const { t, lang, setLang } = useI18n();
  const [form, setForm] = useState({ login: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept-Language': getAcceptLanguageHeader() },
        body: JSON.stringify({ login: form.login, password: form.password })
      });
      if (!res.ok) throw new Error(t('Неверный логин или пароль'));
      const data = await res.json();
      if (!data.user || !data.user.api_token) throw new Error(t('Ошибка авторизации'));
      login({
        id: data.user.id,
        role: data.user.role,
        name: data.user.name,
        api_token: data.user.api_token,
        login: data.user.login
      });
    } catch (e) {
      setError(e.message || t('Ошибка входа'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f7f8fa' }}>
      <Paper sx={{ p: 4, minWidth: 340, minHeight: 220, boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>{t('Вход в админ-панель')}</Typography>
          <Stack direction="row" spacing={0.5}>
            {SUPPORTED_LANGS.map((item) => (
              <Button
                key={item.code}
                size="small"
                onClick={() => setLang(item.code)}
                sx={{
                  minWidth: 70,
                  width: 70,
                  color: lang === item.code ? '#1976d2' : '#555',
                  fontWeight: 700,
                  textTransform: 'none',
                  bgcolor: lang === item.code ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                  '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.12)' },
                  borderRadius: 999,
                  px: 1,
                  gap: 0.4,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: '"Google Sans Flex", "Google Sans", "Helvetica Neue", sans-serif',
                }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <img
                    src={item.icon}
                    alt={item.label}
                    style={{ width: 18, height: 14, borderRadius: 2, objectFit: 'cover' }}
                    onError={(e) => { e.currentTarget.style.display = 'none'; e.currentTarget.parentElement.textContent = item.flag || item.code.toUpperCase(); }}
                  />
                  <span style={{ fontSize: 14, fontWeight: 700, minWidth: 20, textAlign: 'center', display: 'inline-block' }}>
                    {item.code.toUpperCase()}
                  </span>
                </span>
              </Button>
            ))}
          </Stack>
        </Stack>
        <form onSubmit={handleSubmit}>
          <TextField
            label={t('Логин')}
            name="login"
            value={form.login}
            onChange={handleChange}
            fullWidth
            autoFocus
            sx={{ mb: 2 }}
            disabled={loading}
          />
          <TextField
            label={t('Пароль')}
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            fullWidth
            sx={{ mb: 1 }}
            disabled={loading}
            error={!!error}
            helperText={error || ' '}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading || !form.login || !form.password}
            sx={{ fontWeight: 600, bgcolor: '#111', color: '#fff', '&:hover': { bgcolor: '#222' } }}
          >
            {loading ? <CircularProgress size={24} /> : t('Войти')}
          </Button>
        </form>
      </Paper>
    </Box>
  );
} 